import React, { CSSProperties, PropsWithChildren, RefObject } from 'react';

type TableRow = {
  id?: string;
  className?: string;
  style?: CSSProperties;
  ref?: RefObject<HTMLTableRowElement | null>;
  tabIndex?: number;
};

export function TableRow({ children, className, id, style, ref, tabIndex }: PropsWithChildren<TableRow>) {
  return (
    <tr id={id} className={className || 'tables__row'} style={style} ref={ref} tabIndex={tabIndex}>
      {children}
    </tr>
  );
}
